/**
 * UserAccountPage React component
 * 
 * @author    Jens Gruschel
 * @copyright © 2019 contexagon GmbH
 */


// React
import React from 'react';
import connect from "react-redux/es/connect/connect";

// Material UI
import {withStyles} from "@material-ui/core";

// Material UI components
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Button from "@material-ui/core/Button/Button";
import Typography from '@material-ui/core/Typography';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import TextField from '@material-ui/core/TextField';

// icons
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

// application
import {changeOwnPassword} from "../../operations/useraccount";

/**
 * UserAccountPage is a page for managing a user account
 */
class UserAccountPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            tabIndex: 0,
            oldPassword: "",
            newPassword: "",
            confirmedPassword: ""
        }
    }

    render() {

        const { tabIndex } = this.state;
        const { classes } = this.props;
        const userInfo = this.props.userInfo || {};

        return (
            <div>
                <Tabs value={tabIndex} onChange={(event, index) => this.setState({tabIndex: index})}>
                    <Tab label="Account" />
                </Tabs>

                {
                    tabIndex === 0 && <div className={classes.tabContent}>
                        <ExpansionPanel defaultExpanded={true}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                id="userpanel"
                            >
                                <Typography className={classes.heading}>Benutzerdaten</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <div className={classes.detailsPage}>
                                    <TextField className={classes.textField} label={"E-Mail"} value={userInfo.id} fullWidth/>
                                    <TextField className={classes.textField} label={"Name"} value={userInfo.name} fullWidth/>
                                </div>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        {
                            this.props.canChangeOwnPassword && <ExpansionPanel defaultExpanded={true}>
                                <ExpansionPanelSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    id="passwordpanel"
                                >
                                    <Typography className={classes.heading}>Password</Typography>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails>
                                    <div className={classes.detailsPage}>
                                        <TextField
                                            className={classes.textField}
                                            label={"aktuelles Passwort"}
                                            value={this.state.oldPassword}
                                            type="password"
                                            fullWidth
                                            onChange={event => {
                                                this.setState({oldPassword: event.target.value});
                                            }}
                                        />
                                        <TextField
                                            className={classes.textField}
                                            label={"neues Passwort (mindestens 8 Zeichen)"}
                                            value={this.state.newPassword}
                                            type="password"
                                            fullWidth
                                            onChange={event => {
                                                this.setState({newPassword: event.target.value});
                                            }}
                                        />
                                        <TextField
                                            className={classes.textField}
                                            label={"neues Passwort (Bestätigung)"}
                                            value={this.state.confirmedPassword}
                                            type="password"
                                            fullWidth
                                            onChange={event => {
                                                this.setState({confirmedPassword: event.target.value});
                                            }}
                                        />
                                        <Button variant="outlined"
                                            className={classes.button}
                                            disabled={!this.state.newPassword || this.state.newPassword.length < 8 || this.state.newPassword !== this.state.confirmedPassword}
                                            onClick={() => {
                                                this.props.changeOwnPassword(this.state.oldPassword, this.state.newPassword);
                                                this.setState({
                                                    oldPassword: "",
                                                    newPassword: "",
                                                    confirmedPassword: ""
                                                });
                                            }}
                                        >ändern</Button>
                                    </div>
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                        }
                    </div>
                }
            </div>
        );
    }
}

const styles = theme => ({
    tabContent: {
        marginTop: theme.spacing.unit
    },
    detailsPage: {
        width: "100%"
    },
    button: {
        marginRight: theme.spacing.unit,
        marginTop: theme.spacing.unit,
        marginBottom: theme.spacing.unit
    },
    leftIcon: {
        marginRight: theme.spacing.unit
    },
    textField: {
        marginTop: 16,
        marginBottom: 8,
    },
});

const mapStateToProps = state => {
    return {
        userInfo: state.authorization.userInfo,
        canChangeOwnPassword: state.authorization.userPrivileges.changeOwnPassword
    }
};

export default connect(mapStateToProps, {changeOwnPassword})(withStyles(styles)(UserAccountPage));
